var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-alert',{staticClass:"mt-3 mb-3 w-100",attrs:{"variant":"light","show":""}},[_c('div',{staticClass:"text-center"},[_c('fa-icon',{attrs:{"icon":"circle-notch","size":"4x","spin":""}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }